
import {Component, Vue} from "vue-property-decorator";
import ContentPageLayout from "@/components/UI/renewal/ContentPageLayout.vue";
import NotFoundContent from "@/components/not-found/NotFoundContent.vue";

@Component({
  components: {
    ContentPageLayout,
    NotFoundContent,
  },
})
export default class NotFound extends Vue {
}
